/* ============================================================
   COVRPACK — Page Produit Custom v2.1
   Fichier : assets/covrpack-product.js
   ============================================================ */

(function () {
  'use strict';

  var CVR = {
    qty:            1,
    currentTab:     '',
    currentTierIdx: 0,
    tiers:          null,
    tabList:        null,
    subMode:        'once',
    carousels:      {},
    variants:       [],
  };

  /* ── INITIALISATION ── */
  document.addEventListener('DOMContentLoaded', function () {
    if (window.ShopifyProduct && window.ShopifyProduct.variants) {
      CVR.variants = window.ShopifyProduct.variants;
    }

    if (window.cvrTiersData) {
      CVR.tiers = window.cvrTiersData;

      CVR.tabList = Object.keys(CVR.tiers).map(function (sku) {
        var variant = CVR.variants.find(function (v) { return v.sku === sku; });
        return { sku: sku, label: variant ? variant.title : sku, variantId: variant ? variant.id : null };
      });

      var currentId = parseInt(document.querySelector('.cvr-product').dataset.variantId, 10);
      var currentVariant = CVR.variants.find(function (v) { return v.id === currentId; });
      CVR.currentTab = (currentVariant && CVR.tiers[currentVariant.sku]) ? currentVariant.sku : (CVR.tabList[0] ? CVR.tabList[0].sku : '');

      renderTabs();
      renderHybridTable();
    }

    initStickyBar();
    initCarousels();
  });

  /* ── GALERIE ── */
  window.cvrSwitchImage = function (btn) {
    var img = document.getElementById('cvr-main-img');
    if (!img) return;
    img.style.opacity = '0.5';
    setTimeout(function () {
      img.src = btn.dataset.src;
      img.alt = btn.dataset.alt || '';
      img.style.opacity = '1';
    }, 150);
    document.querySelectorAll('.cvr-gallery__thumb').forEach(function (t) { t.classList.remove('is-active'); });
    btn.classList.add('is-active');
  };

  /* ── ONGLETS TABLEAU DÉGRESSIF ── */
  function renderTabs() {
    var container = document.getElementById('cvr-ht-tabs');
    if (!container || !CVR.tabList) return;
    var html = '';
    CVR.tabList.forEach(function (tab) {
      var isActive = tab.sku === CVR.currentTab ? 'is-active' : '';
      html += '<button class="cvr-ht-tab ' + isActive + '" data-sku="' + tab.sku + '" onclick="cvrSwitchHT(\'' + tab.sku + '\', this)">' + tab.label + '</button>';
    });
    container.innerHTML = html;
  }

  function getUnitsForSku(sku) {
    var tab = CVR.tabList ? CVR.tabList.find(function (t) { return t.sku === sku; }) : null;
    if (tab) {
      var match = tab.label.match(/(\d[\d\s]*)/);
      if (match) return parseInt(match[1].replace(/\s/g, ''), 10);
    }
    return 1;
  }

  window.cvrSwitchHT = function (sku, btn) {
    CVR.currentTab = sku;
    CVR.currentTierIdx = 0;
    document.querySelectorAll('.cvr-ht-tab').forEach(function (b) { b.classList.remove('is-active'); });
    btn.classList.add('is-active');

    var tab = CVR.tabList ? CVR.tabList.find(function (t) { return t.sku === sku; }) : null;
    if (tab && tab.variantId) {
      document.querySelector('.cvr-product').dataset.variantId = tab.variantId;
      var v = CVR.variants.find(function (v) { return v.id === tab.variantId; });
      if (v) {
        window.cvrBasePrice = v.price;
        var refEl = document.getElementById('cvr-ref');
        if (refEl && v.sku) refEl.textContent = 'Réf. ' + v.sku;
      }
    }

    renderHybridTable();
    setTimeout(function () { selectTier(0); }, 0);
  };

  function getCurrentSku() {
    if (CVR.tiers && CVR.tiers[CVR.currentTab]) return CVR.currentTab;
    var variantId = parseInt(document.querySelector('.cvr-product').dataset.variantId, 10);
    if (variantId && CVR.variants.length) {
      var v = CVR.variants.find(function (v) { return v.id === variantId; });
      if (v && v.sku && CVR.tiers && CVR.tiers[v.sku]) return v.sku;
    }
    return CVR.currentTab;
  }

  function renderHybridTable() {
    var body = document.getElementById('cvr-ht-body');
    if (!body || !CVR.tiers) return;

    var sku = getCurrentSku();
    var data = CVR.tiers[sku];
    if (!data || !data.length) {
      body.innerHTML = '<div class="cvr-ht-loading">Tarifs non configurés.</div>';
      return;
    }

    var units = getUnitsForSku(sku);
    var basePriceUnit = data[0].unit_price;
    var html = '<table class="cvr-ht-table"><thead><tr><th>Quantité</th><th>Prix / lot</th><th>Réduction</th></tr></thead><tbody>';

    data.forEach(function (tier, i) {
      var discount = i === 0 ? 0 : Math.round((1 - tier.unit_price / basePriceUnit) * 100);
      var isActive = i === CVR.currentTierIdx ? 'is-active' : '';
      var badgeClass = discount > 0 ? 'has-discount' : '';
      var totalUnits = tier.qty * units;
      var qtyLabel = tier.qty === 1 ? '1 lot' : tier.qty + ' lots';
      html += '<tr class="' + isActive + '" data-tier-idx="' + i + '" data-sku="' + sku + '" onclick="cvrSelectTier(this)">';
      html += '<td>' + qtyLabel + ' <span style="color:var(--cvr-grey);font-size:11px;">(' + formatNum(totalUnits) + ' u)</span></td>';
      html += '<td style="font-weight:700;">' + formatPrice(tier.unit_price) + ' €</td>';
      html += '<td><span class="cvr-ht-badge ' + badgeClass + '">' + (discount > 0 ? '-' + discount + '%' : '—') + '</span></td>';
      html += '</tr>';
    });

    html += '</tbody></table>';
    body.innerHTML = html;
    selectTier(CVR.currentTierIdx);
  }

  window.cvrSelectTier = function (row) {
    CVR.currentTab = row.dataset.sku;
    CVR.currentTierIdx = parseInt(row.dataset.tierIdx, 10);
    document.querySelectorAll('.cvr-ht-table tbody tr').forEach(function (r) { r.classList.remove('is-active'); });
    row.classList.add('is-active');
    selectTier(CVR.currentTierIdx);
  };

  function selectTier(idx) {
    var sku = getCurrentSku();
    var data = CVR.tiers[sku];
    if (!data || !data[idx]) return;
    CVR.qty = data[idx].qty;
    var qtyInput = document.getElementById('cvr-qty-main');
    if (qtyInput) qtyInput.value = CVR.qty;
    updatePriceDisplay();
  }

  /* ── AFFICHAGE PRIX ── */
  function getSubDiscount() {
    if (CVR.subMode !== 'repeat') return 0;
    var block = document.querySelector('.cvr-sub-block');
    if (!block) return 0;
    return (parseInt(block.dataset.discount, 10) || 5) / 100;
  }

  function updatePriceDisplay() {
    var sku = getCurrentSku();
    var data = CVR.tiers ? CVR.tiers[sku] : null;
    if (!data || !data.length) return;

    var tier           = data[CVR.currentTierIdx];
    var baseTier       = data[0];
    var units          = getUnitsForSku(sku);
    var multiplier     = (CVR.qty > tier.qty && tier.qty > 0) ? CVR.qty / tier.qty : 1;
    var totalQty       = tier.qty * multiplier;
    var totalUnits     = units * totalQty;
    var totalPrice     = tier.unit_price * totalQty;
    var pricePerUnit   = tier.unit_price / units;
    var baseTotalPrice = baseTier.unit_price * totalQty;
    var subDiscount    = getSubDiscount();
    var totalAfterSub  = totalPrice * (1 - subDiscount);

    var elTotal   = document.getElementById('cvr-disp-total');
    var elCrossed = document.getElementById('cvr-disp-crossed');
    var elSavings = document.getElementById('cvr-disp-savings');
    var elUnit    = document.getElementById('cvr-disp-unit');
    var elQty     = document.getElementById('cvr-disp-qty');

    if (elTotal) {
      elTotal.textContent = formatPrice(totalAfterSub) + ' €';
      elTotal.classList.toggle('has-discount', CVR.currentTierIdx > 0 || subDiscount > 0);
    }

    if (elCrossed) {
      if (subDiscount > 0) {
        elCrossed.textContent = formatPrice(totalPrice) + ' €';
        elCrossed.style.display = '';
      } else if (CVR.currentTierIdx > 0 && baseTotalPrice > totalPrice + 0.01) {
        elCrossed.textContent = formatPrice(baseTotalPrice) + ' €';
        elCrossed.style.display = '';
      } else {
        elCrossed.style.display = 'none';
      }
    }

    if (elSavings) {
      var savings = subDiscount > 0 ? totalPrice - totalAfterSub : (CVR.currentTierIdx > 0 ? baseTotalPrice - totalPrice : 0);
      if (savings > 0.01) {
        elSavings.textContent = 'Économie : ' + formatPrice(savings) + ' €';
        elSavings.style.display = '';
      } else {
        elSavings.style.display = 'none';
      }
    }

    if (elUnit) elUnit.textContent = formatPrice(pricePerUnit, 4) + ' €/u';
    if (elQty)  elQty.textContent  = formatNum(Math.round(totalUnits));

    var stickyPrice = document.getElementById('cvr-sticky-price');
    if (stickyPrice) stickyPrice.textContent = formatPrice(totalAfterSub) + ' €';

    updateSubDisplay(totalPrice);
  }

  function updateSubDisplay(base) {
    var elNew = document.getElementById('cvr-sub-price-new');
    if (!elNew) return;
    var discount = getSubDiscount() || 0.05;
    var elOld = document.getElementById('cvr-sub-price-old');
    var elSav = document.getElementById('cvr-sub-savings');
    elNew.textContent = formatPrice(base * (1 - discount)) + ' €';
    if (elOld) elOld.textContent = formatPrice(base) + ' €';
    if (elSav) elSav.textContent = '−' + formatPrice(base * discount) + ' €';
  }

  /* ── QUANTITÉ ── */
  window.cvrAdjustQty = function (delta) {
    var input = document.getElementById('cvr-qty-main');
    var val = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
    input.value = val;
    CVR.qty = val;
    syncTierFromQty(val);
  };

  window.onQtyInput = function (val) {
    CVR.qty = Math.max(1, parseInt(val, 10) || 1);
    syncTierFromQty(CVR.qty);
  };

  function syncTierFromQty(qty) {
    var sku  = getCurrentSku();
    var data = CVR.tiers ? CVR.tiers[sku] : null;
    if (!data) { updatePriceDisplay(); return; }
    var matchIdx = 0;
    for (var i = 0; i < data.length; i++) {
      if (data[i].qty <= qty) matchIdx = i;
    }
    CVR.currentTierIdx = matchIdx;
    document.querySelectorAll('.cvr-ht-table tbody tr').forEach(function (r, i) {
      r.classList.toggle('is-active', i === matchIdx);
    });
    updatePriceDisplay();
  }

  /* ── ABONNEMENT ── */
  window.cvrSubTab = function (mode, btn) {
    CVR.subMode = mode;
    document.querySelectorAll('.cvr-sub-tab').forEach(function (b) { b.classList.remove('is-active'); });
    btn.classList.add('is-active');
    document.getElementById('cvr-sub-once').style.display = mode === 'once' ? '' : 'none';
    document.getElementById('cvr-sub-repeat').style.display = mode === 'repeat' ? '' : 'none';
    updatePriceDisplay();
  };

  /* ── ONGLETS PRODUIT ── */
  window.cvrSwitchTab = function (tab, btn) {
    document.querySelectorAll('.cvr-tab-panel').forEach(function (p) { p.style.display = 'none'; });
    document.querySelectorAll('.cvr-tab').forEach(function (b) { b.classList.remove('is-active'); });
    var panel = document.getElementById('cvr-tab-' + tab);
    if (panel) panel.style.display = '';
    btn.classList.add('is-active');
  };

  /* ── PANIER AJAX ── */
  window.cvrAddToCart = function () {
    var product   = document.querySelector('.cvr-product');
    var variantId = product ? parseInt(product.dataset.variantId, 10) : null;
    if (!variantId) return;
    var qty     = parseInt(document.getElementById('cvr-qty-main').value, 10) || 1;
    var cartBtn = document.getElementById('cvr-add-to-cart');
    if (cartBtn) { cartBtn.disabled = true; cartBtn.textContent = 'Ajout en cours…'; }

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body:    JSON.stringify({ id: variantId, quantity: qty })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('Erreur ' + r.status);
      return r.json();
    })
    .then(function () {
      if (cartBtn) { cartBtn.disabled = false; cartBtn.textContent = '✓ Ajouté !'; }
      setTimeout(function () { if (cartBtn) cartBtn.textContent = 'Ajouter au panier'; }, 2000);
      document.dispatchEvent(new CustomEvent('cart:updated'));
      if (window.theme && window.theme.cart && typeof window.theme.cart.open === 'function') window.theme.cart.open();
    })
    .catch(function (err) {
      console.error('Erreur panier :', err);
      if (cartBtn) { cartBtn.disabled = false; cartBtn.textContent = 'Erreur — réessayer'; }
    });
  };

  /* ── CROSS-SELL ADD TO CART ── */
  window.cvrCsAdd = function (btn) {
    var variantId = parseInt(btn.dataset.variantId, 10);
    var card = btn.closest('.cvr-cs-card');
    var input = card ? card.querySelector('.cvr-cs-qty-input') : null;
    var qty = input ? (parseInt(input.value, 10) || 1) : 1;
    btn.innerHTML = '✓';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('Erreur ' + r.status);
      return r.json();
    })
    .then(function () {
      setTimeout(function () {
  btn.classList.remove('is-added');
  btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>';
}, 1200);
      document.dispatchEvent(new CustomEvent('cart:updated'));
      if (window.theme && window.theme.cart && typeof window.theme.cart.open === 'function') window.theme.cart.open();
    })
    .catch(function () { btn.classList.remove('is-added'); });
  };

  /* ── CARROUSELS ── */
  function initCarousels() {
    CVR.carousels = { compat: 0, bundle: 0 };
    initDots('compat');
    initDots('bundle');
  }

  function initDots(id) {
    setTimeout(function () { renderDots(id); }, 100);
    window.addEventListener('resize', function () { renderDots(id); });
  }

  function getGap(id) { return id === 'bundle' ? 10 : 8; }

  window.cvrSlide = function (id, dir) {
    var track = document.getElementById('cvr-' + id + '-track');
    if (!track) return;
    var cards = track.querySelectorAll('.cvr-cs-card');
    if (!cards.length) return;
    var cardWidth = cards[0].offsetWidth + getGap(id);
    var visible = Math.max(1, Math.floor(track.parentNode.offsetWidth / cardWidth));
    var max = Math.max(0, cards.length - visible);
    CVR.carousels[id] = Math.min(max, Math.max(0, (CVR.carousels[id] || 0) + dir));
    track.style.transform = 'translateX(-' + CVR.carousels[id] * cardWidth + 'px)';
    renderDots(id);
  };

  window.cvrSlideTo = function (id, page) {
    var track = document.getElementById('cvr-' + id + '-track');
    if (!track) return;
    var cards = track.querySelectorAll('.cvr-cs-card');
    if (!cards.length) return;
    var cardWidth = cards[0].offsetWidth + getGap(id);
    var visible = Math.max(1, Math.floor(track.parentNode.offsetWidth / cardWidth));
    var max = Math.max(0, cards.length - visible);
    CVR.carousels[id] = Math.min(max, page * visible);
    track.style.transform = 'translateX(-' + CVR.carousels[id] * cardWidth + 'px)';
    renderDots(id);
  };

  function renderDots(id) {
    var dotsContainer = document.getElementById('cvr-' + id + '-dots');
    var track = document.getElementById('cvr-' + id + '-track');
    if (!dotsContainer || !track) return;
    var cards = track.querySelectorAll('.cvr-cs-card');
    if (!cards.length) return;
    var cardWidth = cards[0].offsetWidth + getGap(id);
    var visible = Math.max(1, Math.floor(track.parentNode.offsetWidth / cardWidth));
    var totalDots = Math.max(1, Math.ceil(cards.length / visible));
    var currentPage = Math.floor((CVR.carousels[id] || 0) / visible);
    var html = '';
    for (var i = 0; i < totalDots; i++) {
      html += '<button class="cvr-carousel-dot' + (i === currentPage ? ' is-active' : '') + '" onclick="cvrSlideTo(\'' + id + '\', ' + i + ')"></button>';
    }
    dotsContainer.innerHTML = html;
  }

  /* ── STICKY BAR ── */
  function initStickyBar() {
    var bar  = document.getElementById('cvr-sticky-bar');
    var hero = document.querySelector('.cvr-hero');
    if (!bar || !hero) return;
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0 }).observe(hero);
  }

  /* ── UTILITAIRES ── */
  function formatPrice(val, decimals) {
    return parseFloat(val).toFixed(decimals !== undefined ? decimals : 2).replace('.', ',');
  }

  function formatNum(val) {
    return parseInt(val, 10).toLocaleString('fr-FR');
  }

})();